<template>
  <div>
    <div class="text-h6 q-pb-md">Choose your prefer customer ?</div>
    <div class="top column">
      <q-input
        dense
        rounded
        color="white"
        bg-color="white"
        outlined
        v-model="searchCustomer.keyword"
        placeholder="Search customer"
        style="margin: 10px 0"
        ><template v-slot:prepend>
          <q-icon name="person_search" color="gray-10" /></template
      ></q-input>
      <div class="row justify-end">
        <q-btn
          dense
          flat
          color="white"
          icon="edit"
          label="Edit selected customer"
          no-wrap
          no-caps
          @click="onEditCustomer"
          v-close-popup
        />
      </div>
    </div>
    <q-list bordered class="bg-white">
      <q-item
        clickable
        v-for="(customer, index) in filteredCustomer"
        :key="index"
        :active="customer.id === activeCustomerID"
        active-class="bg-grey-4"
        @click="onChange(customer)"
      >
        <q-item-section avatar>
          <q-avatar size="md" color="primary" text-color="white">{{
            customer.firstname.charAt(0).toUpperCase()
          }}</q-avatar>
        </q-item-section>

        <q-item-section no-wrap>
          <q-item-label class="text-primary"
            >{{ customer.firstname }} {{ customer.lastname }}</q-item-label
          >
          <q-item-label caption>{{ customer.address[0].phone }}</q-item-label>
          <q-item-label caption>{{ customer.address[0].email }}</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script>
import {
  QTabs,
  QTab,
  QInnerLoading,
  //   QSpinnerGears,
  QList,
  QItem,
  QItemLabel,
  QItemSection,
  QInput,
} from "quasar";
import { mapState } from "vuex";
const components = {
  QTabs,
  QTab,
  QInnerLoading,
  //   QSpinnerGears,
  QList,
  QItem,
  QItemLabel,
  QItemSection,
  QInput,
};
export default {
  name: "AllCustomerDialog",
  components: {
    ...components,
  },
  data() {
    return {
      tab: null,
      visible: false,
      searchCustomer: {
        keyword: "",
      },
    };
  },
  computed: {
    ...mapState({
      customers: (state) => state["sale"]["customers"],
      activeCustomerID: (state) => state["activeCustomer"]["customer"]["id"],
    }),

    filteredCustomer() {
      if (this.searchCustomer.keyword) {
        if (isNaN(this.searchCustomer.keyword)) {
          console.log("search by name");
          return this.customers.filter((c) => {
            const result = c.firstname
              .toLowerCase()
              .search(this.searchCustomer.keyword.toLowerCase());
            if (result !== -1) {
              return true;
            }
            return false;
          });
        } else {
          console.log("search by phone");
          return this.customers.filter((c) => {
            const result = c.phone_number.search(this.searchCustomer.keyword);
            if (result !== -1) {
              return true;
            }
            return false;
          });
        }
      }
      return this.customers;
    },
  },
  //   mounted() {},
  methods: {
    async onChange(customer) {
      this.$emit("choosed-customer", customer);
    },
    onEditCustomer() {
      console.log("onEditCustomer");
      this.$router.push({ name: "UpdateCustomer" });
    },
  },
};
</script>

<style scoped>

.tab-content-class {
  text-transform: none;
  justify-content: flex-start;
}
.tab {
  justify-content: flex-start !important;
}
.bg-primary-2 {
  background-color: #c0bfd5;
}
.bg-primary-2::before {
  content: "";
  position: absolute;
  top: 0px;
  height: 2px;
  background-color: #2c2a74;
  left: 0px;
  right: 0px;
}
.bg-primary-2::after {
  content: "";
  position: absolute;
  /* top: 0px; */
  height: 2px;
  background-color: #2c2a74;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

</style>